import axios from "../utils/axios";

export const getAllOrgStructureItems = async (page = 1, per_page = 15, filters = {}) => {
    const params = { ...filters };
    if (page) params.page = page;
    if (per_page) params.per_page = per_page;
    const { data } = await axios.get('/org-structure-items', { params });
    return data;
};

export const getOrgStructureItemsForSelect = async () => {
    const { data } = await axios.get('/org-structure-items/for-select');
    return data;
};

export const getOrgStructureItemsTree = async () => {
    const { data } = await axios.get('/org-structure-items/tree');
    return data;
};

export const getOrgStructureItem = async (id) => {
    const { data } = await axios.get(`/org-structure-items/${id}`);
    return data;
};

export const createOrgStructureItem = async (req) => {
    const { data } = await axios.post('/org-structure-items', req, { headers: { Accept: 'application/json' } });
    return data;
};

export const updateOrgStructureItem = async (req, id) => {
    const { data } = await axios.put(`/org-structure-items/${id}`, req, { headers: { Accept: 'application/json' } });
    return data;
};

export const deleteOrgStructureItem = async (id) => {
    const { data } = await axios.delete(`/org-structure-items/${id}`, { headers: { Accept: 'application/json' } });
    return data;
};

export const deleteAllOrgStructureItems = async (req) => {
    const { data } = await axios.delete('/org-structure-items/mass-destroy', { data: req, headers: { Accept: 'application/json' } });
    return data;
};

export const forceDeleteOrgStructureItem = async (id) => {
    const { data } = await axios.delete(`/org-structure-items/${id}/force-delete`, { headers: { Accept: 'application/json' } });
    return data;
};

export const forceDeleteAllOrgStructureItems = async (ids) => {
    const { data } = await axios.delete('/org-structure-items/mass-force-delete', { data: ids, headers: { Accept: 'application/json' } });
    return data;
};

export const restoreOrgStructureItem = async (id) => {
    const { data } = await axios.post(`/org-structure-items/${id}/restore`, {}, { headers: { Accept: 'application/json' } });
    return data;
};

export const restoreAllOrgStructureItems = async (req) => {
    const { data } = await axios.post('/org-structure-items/mass-restore', req, { headers: { Accept: 'application/json' } });
    return data;
};
